import { defineSlotRecipe as o } from "@pandacss/dev";
import { anatomy as e } from "../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/dialog/dist/index.mjs";
const t = o({
  className: "dialog",
  slots: e.keys(),
  base: {
    content: {
      backgroundColor: "base.white",
      borderRadius: "6",
      border: "none"
    }
  }
});
export {
  t as dialog
};
